import "./sentry";
import { main, registerComponents } from '@eastsideco/salvo-ts';
import './assets/styles/theme.scss';

const imports = import.meta.glob('./components/**/*.(ts|js|tsx|jsx)', {
  eager: true
});

interface RequireContext {
  (id: string): unknown;
  keys(): string[];
}

function makeRequireContext(imports: Record<string, unknown>): RequireContext {
  const require = (id: string) => imports[id];
  require.keys = () => Object.keys(imports);
  return require;
}

// Register components with SALVO-TS
registerComponents(
    makeRequireContext(imports),
    undefined
);


// Initialize theme
export const theme = main({
  enableLegacySalvoLiteComponentSupport: true,
});